import BodyNodes from "./body-nodes";
import Body from "./Body";
import Label from "./Label";
import NextSection from "./NextSection";
import Pagination from "./Pagination";
import Text from "./Text";

export default {
  BodyNodes,
  Body,
  Label,
  NextSection,
  Pagination,
  Text
};
